var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discount"},[(_vm.errored)?_c('ErrorScreen'):_vm._e(),(_vm.loading)?_c('LoadingScreen'):_vm._e(),(!_vm.loading && !_vm.errored)?_c('DiscountDetails',{attrs:{"discount":_vm.discount}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }